import React, { useState, useEffect, useContext } from "react";
import "../../../constants/report.css";
import axios from "axios";
import { formatDate } from "../../../constants/helper";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl } from "../../../contexts/ContextProvider";
import { Loader } from "../../../components";
import {
  Alert,
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Container, Form } from "react-bootstrap";
import SearchIcon from "@mui/icons-material/Search";

const RekalkulasiStok = () => {
  const { user } = useContext(AuthContext);
  let [sampaiTanggal, setSampaiTanggal] = useState(
    new Date(user.tutupperiode.sampaiTanggal)
  );
  let [dariTanggal, setDariTanggal] = useState(
    new Date(user.tutupperiode.dariTanggal)
  );

  const [loading, setLoading] = useState(false);
  const [persenLoading, setPersenLoading] = useState("0");
  const [rekalkulasiStoks, setRekalkulasiStoks] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");

  const requestPayload = () => ({
    tglRekalkulasiStok: sampaiTanggal,
    dariTanggal,
    sampaiTanggal,
    kodeCabang: user.cabang.id,
    _id: user.id,
    token: user.token,
  });

  const getRekalkulasiStoks = async () => {
    const response = await axios.post(
      `${tempUrl}/rekalkulasiStoks`,
      requestPayload(),
    );
    setRekalkulasiStoks(Array.isArray(response.data) ? response.data : []);
  };

  const tampilPdf = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity()) {
      setLoading(true);
      setErrorMessage("");
      let tempPersenLoading = parseInt(persenLoading);

      setTimeout(() => {
        tempPersenLoading += 40;
        setPersenLoading(tempPersenLoading.toString());
      }, "1000");

      try {
        await axios.post(`${tempUrl}/prosesRekalkulasiStok`, {
          sampaiTanggal,
          dariTanggal,
          userIdInput: user.id,
          kodeCabang: user.cabang.id,
          _id: user.id,
          token: user.token,
        });
        await getRekalkulasiStoks();
      } catch (error) {
        setErrorMessage(
          error.response?.data?.message || "Rekalkulasi stok gagal diproses.",
        );
      } finally {
        setLoading(false);
      }
      setTimeout(() => {
        tempPersenLoading = 0;
        setPersenLoading(tempPersenLoading.toString());
      }, "2000");
    }
  };

  useEffect(() => {
    if (user?.id && user?.cabang?.id) {
      getRekalkulasiStoks().catch((error) => {
        setErrorMessage(
          error.response?.data?.message ||
            "Daftar hasil rekalkulasi stok gagal dimuat.",
        );
      });
    }
  }, [user?.id, user?.cabang?.id]);

  const formatNumber = (value) =>
    Number(value || 0).toLocaleString("de-DE", {
      maximumFractionDigits: 4,
    });

  const total = rekalkulasiStoks.reduce(
    (result, row) => {
      result.saldoAwalQuantity += Number(row.saldoAwalQuantity) || 0;
      result.debetQuantity += Number(row.debetQuantity) || 0;
      result.kreditQuantity += Number(row.kreditQuantity) || 0;
      result.saldoAkhirQuantity += Number(row.saldoAkhirQuantity) || 0;
      result.saldoAwalRupiah += Number(row.saldoAwalRupiah) || 0;
      result.debetRupiah += Number(row.debetRupiah) || 0;
      result.kreditRupiah += Number(row.kreditRupiah) || 0;
      result.saldoAkhirRupiah += Number(row.saldoAkhirRupiah) || 0;
      return result;
    },
    {
      saldoAwalQuantity: 0,
      debetQuantity: 0,
      kreditQuantity: 0,
      saldoAkhirQuantity: 0,
      saldoAwalRupiah: 0,
      debetRupiah: 0,
      kreditRupiah: 0,
      saldoAkhirRupiah: 0,
    },
  );

  if (loading) {
    return <Loader persenLoading={persenLoading} />;
  }

  return (
    <Container>
      <h3>Transaksi</h3>
      <h5 style={{ fontWeight: 400 }}>Rekalkulasi Stok</h5>
      <Typography sx={subTitleText}>
        Periode : {user.tutupperiode.namaPeriode}
      </Typography>
      <hr />
      {errorMessage && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {errorMessage}
        </Alert>
      )}
      <Box>
        <Form onSubmit={tampilPdf}>
          <Button
            variant="contained"
            startIcon={<SearchIcon />}
            type="submit"
            style={{ marginTop: "20px" }}
          >
            PROSES
          </Button>
        </Form>
      </Box>
      {/*
      <Box sx={resultSectionSx}>
        <Typography variant="h6" sx={resultTitleSx}>
          Daftar Hasil Rekalkulasi Stok
        </Typography>
        <Typography variant="body2" sx={resultMetaSx}>
          Tanggal hasil: {formatDate(sampaiTanggal)} | Total stok: {rekalkulasiStoks.length}
        </Typography>
        <TableContainer
          component={Paper}
          elevation={0}
          className="table-responsive border rounded-3 shadow-sm"
          sx={tableContainerSx}
        >
          <Table stickyHeader size="small" className="table table-hover align-middle mb-0">
            <TableHead sx={tableHeadSx}>
              <TableRow>
                <TableCell sx={tableHeaderCellSx}>Tanggal</TableCell>
                <TableCell sx={tableHeaderCellSx}>Kode Stok</TableCell>
                <TableCell sx={tableHeaderCellSx}>Nama Stok</TableCell>
                <TableCell align="right" sx={tableHeaderCellSx}>Saldo Awal Qty</TableCell>
                <TableCell align="right" sx={tableHeaderCellSx}>Debet Qty</TableCell>
                <TableCell align="right" sx={tableHeaderCellSx}>Kredit Qty</TableCell>
                <TableCell align="right" sx={tableHeaderCellSx}>Saldo Akhir Qty</TableCell>
                <TableCell align="right" sx={tableHeaderCellSx}>Saldo Awal Rp</TableCell>
                <TableCell align="right" sx={tableHeaderCellSx}>Debet Rp</TableCell>
                <TableCell align="right" sx={tableHeaderCellSx}>Kredit Rp</TableCell>
                <TableCell align="right" sx={tableHeaderCellSx}>Saldo Akhir Rp</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rekalkulasiStoks.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={11} align="center" sx={emptyCellSx}>
                    Belum ada hasil rekalkulasi untuk periode ini. Klik PROSES untuk menghitung.
                  </TableCell>
                </TableRow>
              ) : (
                <>
                  {rekalkulasiStoks.map((row) => (
                    <TableRow
                      hover
                      key={row.id || `${row.tglRekalkulasiStok}-${row.stokId}`}
                      sx={tableBodyRowSx}
                    >
                      <TableCell sx={tableBodyCellSx}>{formatDate(row.tglRekalkulasiStok)}</TableCell>
                      <TableCell sx={codeCellSx}>{row.stok?.kodeStok || "-"}</TableCell>
                      <TableCell sx={nameCellSx}>{row.stok?.namaStok || "-"}</TableCell>
                      <TableCell align="right" sx={numberCellSx}>{formatNumber(row.saldoAwalQuantity)}</TableCell>
                      <TableCell align="right" sx={numberCellSx}>{formatNumber(row.debetQuantity)}</TableCell>
                      <TableCell align="right" sx={numberCellSx}>{formatNumber(row.kreditQuantity)}</TableCell>
                      <TableCell align="right" sx={numberCellSx}>{formatNumber(row.saldoAkhirQuantity)}</TableCell>
                      <TableCell align="right" sx={numberCellSx}>{formatNumber(row.saldoAwalRupiah)}</TableCell>
                      <TableCell align="right" sx={numberCellSx}>{formatNumber(row.debetRupiah)}</TableCell>
                      <TableCell align="right" sx={numberCellSx}>{formatNumber(row.kreditRupiah)}</TableCell>
                      <TableCell align="right" sx={numberCellSx}>{formatNumber(row.saldoAkhirRupiah)}</TableCell>
                    </TableRow>
                  ))}
                  <TableRow sx={totalRowSx}>
                    <TableCell colSpan={3} sx={totalLabelSx}>TOTAL</TableCell>
                    <TableCell align="right" sx={totalNumberSx}>{formatNumber(total.saldoAwalQuantity)}</TableCell>
                    <TableCell align="right" sx={totalNumberSx}>{formatNumber(total.debetQuantity)}</TableCell>
                    <TableCell align="right" sx={totalNumberSx}>{formatNumber(total.kreditQuantity)}</TableCell>
                    <TableCell align="right" sx={totalNumberSx}>{formatNumber(total.saldoAkhirQuantity)}</TableCell>
                    <TableCell align="right" sx={totalNumberSx}>{formatNumber(total.saldoAwalRupiah)}</TableCell>
                    <TableCell align="right" sx={totalNumberSx}>{formatNumber(total.debetRupiah)}</TableCell>
                    <TableCell align="right" sx={totalNumberSx}>{formatNumber(total.kreditRupiah)}</TableCell>
                    <TableCell align="right" sx={totalNumberSx}>{formatNumber(total.saldoAkhirRupiah)}</TableCell>
                  </TableRow>
                </>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      */}
    </Container>
  );
};

export default RekalkulasiStok;

const spacingTop = {
  mt: 4,
};

const pdfContainer = {
  padding: "20px",
  letterSpacing: "0.01px",
  fontSize: "10px",
  fontFamily: "sans-serif",
  width: "1000px",
};

const subTitleText = {
  fontWeight: "900",
};

const resultSectionSx = {
  mt: 4,
  mb: 4,
};

const resultTitleSx = {
  mb: 0.5,
  fontWeight: 700,
  color: "#173b70",
};

const resultMetaSx = {
  mb: 2,
  color: "#6c757d",
};

const tableContainerSx = {
  maxHeight: 600,
  backgroundColor: "#fff",
  borderColor: "#dbe5f1 !important",
  overflow: "auto",
  "&::-webkit-scrollbar": {
    width: 8,
    height: 8,
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9bb8d8",
    borderRadius: 8,
  },
};

const tableHeadSx = {
  "& .MuiTableCell-stickyHeader": {
    backgroundColor: "#0d6efd",
  },
};

const tableHeaderCellSx = {
  minWidth: 120,
  padding: "13px 14px",
  color: "#fff",
  fontWeight: 700,
  fontSize: "0.78rem",
  lineHeight: 1.35,
  letterSpacing: "0.02em",
  whiteSpace: "nowrap",
  borderColor: "rgba(255,255,255,0.22)",
};

const tableBodyRowSx = {
  "&:nth-of-type(even)": {
    backgroundColor: "#f8fbff",
  },
  "&:hover": {
    backgroundColor: "#eaf3ff !important",
  },
};

const tableBodyCellSx = {
  padding: "11px 14px",
  color: "#344054",
  fontSize: "0.86rem",
  whiteSpace: "nowrap",
  borderColor: "#e9eef5",
};

const codeCellSx = {
  ...tableBodyCellSx,
};

const nameCellSx = {
  ...tableBodyCellSx,
  minWidth: 220,
  whiteSpace: "normal",
};

const numberCellSx = {
  ...tableBodyCellSx,
  minWidth: 125,
  fontVariantNumeric: "tabular-nums",
  color: "#1f2937",
};

const emptyCellSx = {
  padding: "42px 20px",
  color: "#6c757d",
  fontStyle: "italic",
  borderColor: "#e9eef5",
};

const totalRowSx = {
  "& td": {
    background: "linear-gradient(135deg, #e7f1ff 0%, #d7e8ff 100%)",
    borderTop: "2px solid #0d6efd",
    borderColor: "#b9d3f5",
  },
};

const totalLabelSx = {
  padding: "13px 14px",
  color: "#0b3d7a",
  fontWeight: 800,
  letterSpacing: "0.04em",
};

const totalNumberSx = {
  ...numberCellSx,
  padding: "13px 14px",
  color: "#0b3d7a",
  fontWeight: 800,
};
